import { createStyles } from "antd-style";

const useDetailsScreenStyles = createStyles(({ css }) => {
  return {
    screen: css`
      flex: 1 0;
      .bodyWrapper {
        padding: var(--Global-token-Padding-padding, 16px);
        border-radius: var(--Global-token-Radius-radiusXL, 24px);
        background: var(--Global-token-Bg-colorBgBase, #fff);

        .title {
          color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
          text-align: center;
          font-feature-settings: "liga" off, "clig" off;

          /* MD/Headline/Semibold */
          font-size: 15px;
          font-style: normal;
          font-weight: 600;
          line-height: 112%; /* 16.8px */
        }

        .divider {
          margin: 0;
        }

        .details {
        }

        .detailsItem {
          .icon {
            width: 40px;
            height: 40px;
            padding: var(--Global-token-Padding-paddingS, 8px);
            border-radius: var(--Global-token-Radius-radiusSM, 8px);
            background: var(--Data-Display-Tabs-colorTabBg, #f5f5f5);
          }

          .detailsBody {
            flex: 1 0;

            .detailsTitle {
              color: var(--Global-token-Text-colorText, rgba(0, 0, 0, 0.88));
              font-feature-settings: "liga" off, "clig" off;

              /* MD/Callout/Regular */
              font-size: 13px;
              font-style: normal;
              font-weight: 400;
              line-height: 120%; /* 15.6px */
              margin-bottom: 4px;
            }

            .detailsText {
              color: var(--Global-token-Text-colorTextDescription, rgba(0, 0, 0, 0.45));
              font-feature-settings: "liga" off, "clig" off;

              /* MD/Footnote/Regular */
              font-size: 11px;
              font-style: normal;
              font-weight: 400;
              line-height: 110%; /* 12.1px */
            }
          }

          .edit {
          }
        }
      }
    `,
    footer: css`
      margin-top: auto;
      border-radius: var(--Global-token-Radius-radiusXL, 24px) var(--Global-token-Radius-radiusXL, 24px) 0 0;
      background: var(--Global-token-Bg-colorBgBase, #fff);
      padding: 8px 16px;
    `,
  };
});
export default useDetailsScreenStyles;
